export default "__VITE_ASSET__w3pkJzKx__"